import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";

function ContactPage() {
  const { t } = useTranslation();

  return (
    <div
      className="contact-page"
      style={{ padding: "4rem 2rem", maxWidth: "1100px", margin: "0 auto" }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "2rem" }}>
        {t("contact.title")}
      </h1>

      <div style={{ display: "grid", gap: "2rem", alignItems: "center" }}>
        <img
          src="/images/support2.png"
          alt={t("contact.imageAlt")}
          style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}
        />

        <div>
          <h2 style={{ marginBottom: "1rem" }}>{t("contact.subtitle")}</h2>
          <p style={{ marginBottom: "1.5rem", lineHeight: "1.8" }}>
            {t("contact.description")}
          </p>

          <p>
            <strong>Email:</strong> support@onenizer.com
          </p>
          <p>
            <strong>Telefon:</strong> 012 2345 234 23
          </p>
          <p>
            <strong>Support:</strong> Montag – Freitag: 9:00 – 18:00 Uhr
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
